import { STATUS_REQUERIMENTO, ENUM_CARGO } from 'utils/consts';
import { formatterStatusSetorialIniciandoFrontToBack } from 'utils/formatter/status';
import {
  fetchAlterarStatusSetorial,
  fetchAlterarStatusFormulario,
  fetchDetalharFormularioPorId,
} from 'store/fetchActions/fetchFormulario';

export const verificarUsuarioAlterarStatus = (atendenteLogado, statusIdentificadorRequerimento) => {
  const isAtendente = atendenteLogado?.cargoId === ENUM_CARGO.ATENDENTE;
  const isEncaminhadoOrDirecionado =
    statusIdentificadorRequerimento === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador ||
    statusIdentificadorRequerimento === STATUS_REQUERIMENTO.DIRECIONADO_OUTRO_ATENDENTE.identificador;

  return isAtendente && isEncaminhadoOrDirecionado ? true : false;
};

export const handleAlterarStatusAtendenteSetorial = (atendenteLogado, dadosRequerimento, novoStatus) => dispatch => {
  const dadosFormatados = formatterStatusSetorialIniciandoFrontToBack(atendenteLogado, dadosRequerimento, novoStatus);
  dispatch(fetchAlterarStatusSetorial(dadosFormatados)).then(() =>
    dispatch(fetchDetalharFormularioPorId(dadosRequerimento?.id))
  );
  return dadosFormatados;
};

export const handleAlterarStatusAtendente = (dadosRequerimento, novoStatus) => dispatch => {
  dispatch(fetchAlterarStatusFormulario(dadosRequerimento?.id, novoStatus?.id)).then(() =>
    dispatch(fetchDetalharFormularioPorId(dadosRequerimento?.id))
  );
  return { id: dadosRequerimento?.id, statusId: novoStatus?.id };
};
